<!-- #62 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Vendor
      </div>
      <v-spacer></v-spacer>
      <v-btn color="primary" small @click="goToDetails(0)">Create</v-btn>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="_headers"
      :items="vendors"
      :options.sync="options"
      :server-items-length="total"
      :search="search"
      :loading="vendorLoader"
      class="elevation-1 mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-form v-if="userCategory.user_category == 3">
          <v-row class="custom-row pl-5 pr-5">
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="client_name"
                :items="clients"
                outlined
                dense
                chips
                item-text="name"
                item-value="id"
                small-chips
                label="Client name"
                clearable
                @focus="fetchClients"
              ></v-autocomplete>
            </v-col>
            <v-col cols="9" class="text-end pr-4 mb-2">
              <v-btn class="success" color="primary" @click="searchAll"
                >Search</v-btn
              >
              <v-btn color="white" class="ml-4" @click="clearAll()"
                >Clear</v-btn
              >
            </v-col>
          </v-row>
          <v-divider class="mb-2 mt-2"></v-divider>
        </v-form>
      </template>

      <!-- <template v-slot:[`item.billing_address_country_id`]="{ item }">
        {{ getCountryList(item.client_id) }}
      </template> -->
      <template
        v-slot:[`item.action`]="{ item }"
        v-if="checkPermission('app_ecom_vendors:get_vendor_by_id')"
      >
        <span>
          <v-icon class="mr-2" small @click="goToDetails(item.id)">
            mdi-pencil
          </v-icon>
        </span>
      </template>
    </v-data-table>
    <v-dialog
      v-model="vendorPopup"
      max-width="750px"
      @keydown.esc="vendorPopup = false"
      persistent
    >
      <v-card>
        <v-card-title class="p-0">
          <v-toolbar flat style="height: 50px">
            <v-toolbar-title class="mb-2">
              Add Vendor
              <i class="caption red--text ml-4"> * required field</i>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <vendor
            id="0"
            @closePopup="closePopups()"
            @savepopup="savePopups()"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="vendorPopupEdit"
      max-width="750px"
      @keydown.esc="vendorPopupEdit = false"
      persistent
    >
      <v-card>
        <v-card-title class="p-0">
          <v-toolbar flat style="height: 50px">
            <v-toolbar-title class="mb-2">
              Edit Vendor
              <i class="caption red--text ml-4"> * required field</i>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <vendor
            :id="itemId"
            @savepopup="savePopups()"
            @closePopup="closePopups()"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import vendor from "@/components/front/Vendor/Details";

export default {
  components: { vendor },

  computed: {
    ...mapGetters(["userRole", "userCategory", "userTypes"]),
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client_name"
          : true;
      });
    },
  },

  data: () => ({
    dialogConfirm: false,
    search: "",
    vendorPopup: false,
    vendorPopupEdit: false,
    client_name: "",
    headers: [
      {
        text: "Name",
        value: "vendor_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Client Name",
        value: "client_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Code",
        value: "vendor_code",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Billing Address",
        value: "billing_address_line1",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Billing Country",
        value: "billing_country_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Shipping Address",
        value: "shipping_address_line1",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Shipping Country",
        value: "shipping_country_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
      },
    ],
    editedIndex: -1,
    editedItem: {
      type: null,
      name: null,
      description: null,
      active: null,
    },
    defaultItem: null,
    vendors: [],
    options: {},
    total: 0,
    vendorLoader: false,
    clients: [],
    itemId: "",
  }),

  watch: {
    options: {
      handler() {
        this.fetchVendor();
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    ...mapActions([
      "getVendorsList",
      "snackBar",
      "getFulfillmentCountryList",
      "fetchClient",
    ]),
    goToDetails(id) {
      if (id == 0) {
        this.vendorPopup = true;
      } else {
        this.itemId = id;
        this.vendorPopupEdit = true;
      }
      // this.$router.push({
      //   name: "vendorDetails",
      //   params: {
      //     id,
      //   },
      // });
    },

    fetchClients() {
      if (this.clients.length > 0) return;
      this.fetchClient({
        service: "fulfillment,fulfillment_wid_last_mile",
      }).then((res) => {
        this.clients = res.data;
      });
    },
    closePopups() {
      this.vendorPopup = false;
      this.vendorPopupEdit = false;
    },
    savePopups() {
      this.vendorPopup = false;
      this.vendorPopupEdit = false;
      this.fetchVendor();
    },
    fetchVendor() {
      this.vendor = [];
      this.vendorLoader = true;
      this.getVendorsList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.vendorLoader = false;
          this.vendors = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.vendorLoader = false;
        });
    },

    reset() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeConfirm() {
      this.dialogConfirm = false;
      this.vendor[this.editedIndex].active =
        !this.vendor[this.editedIndex].active;
      this.reset();
    },

    confirmStatusChange(item) {
      this.editedIndex = this.vendor.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogConfirm = true;
    },

    changeStatus() {
      this.statusLoader = true;
      this.updateDReport({
        id: this.editedItem.id,
        data: this.editedItem,
      })
        .then((res) => {
          this.statusLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialogConfirm = false;
          this.reset();
        })
        .catch(() => {
          this.statusLoader = false;
          this.closeConfirm();
        });
    },
    async getCountryList(id) {
      await this.getFulfillmentCountryList(id).then((res) => {
        this.dataArray = res.data.response;
        const countryIdMap = new Map();

        this.dataArray.forEach((item) => {
          if (!countryIdMap.has(item.client_country_id)) {
            countryIdMap.set(item.client_country_id, item.country);
          }
        });

        this.allCountries = Array.from(
          countryIdMap,
          ([client_country_id, country]) => ({ client_country_id, country })
        );
      });
    },
    cityList(targetClientId) {
      this.cityLoader = true;
      this.citiesList = this.dataArray
        .filter((item) => item.client_country_id === targetClientId)
        .map((item) => ({
          city: item.city,
          client_city_id: item.client_city_id,
        }));
      this.cityLoader = false;
    },
    goToPreview(id, name) {
      this.$router.push({
        name: "DashBoardsvendorPreview",
        params: {
          id,
        },
        query: {
          name,
        },
      });
    },
    category(type, item) {
      if (type == 1) {
        return `Client (${item.client_name} - ${item.client_type} )`;
      } else if (type == 2) {
        return `Seller (${item.seller_name} - ${item.seller_type} )`;
      } else if (type == 3) {
        return "RSA";
      }
    },

    allFilters() {
      this.vendorLoader = true;
      let obj = {
        clientid: this.client_name,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getVendorsList({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.vendorLoader = false;
          this.vendors = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.vendorLoader = false;
        });
    },
    clearAll() {
      this.client_name = "";
      this.searchAll();
    },
    clearInput(val) {
      if (val != null) {
        val = null;
      }
    },
  },
};
</script>
<style>
.v-picker__title primary {
  display: none;
}
.custom-row .switch label.v-label.theme--light {
  top: 0px !important;
}
</style>
